"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _ = require('lodash');
var _require = require('bson'),
  ObjectId = _require.ObjectId;
var NEW_PROGRAM = 'NEW_PROGRAM';
var EDIT_PROGRAM = 'EDIT_PROGRAM';
module.exports = /*@ngInject*/function ($location, $uibModal, $filter, programs, campuses, ProgramService, ProfileService) {
  var ctrl = this;
  ctrl.isSuper = ProfileService.isSuperUser();
  ctrl.campuses = campuses;
  ctrl.tabs = {
    PARTY: {
      active: true,
      index: 0,
      heading: 'Location/People',
      templateUrl: 'management/party/party.html'
    },
    PROGRAMS_ROLES: {
      active: false,
      index: 1,
      heading: 'Program Roles',
      templateUrl: 'management/program/program.html'
    },
    ROUTING_GROUPS: {
      active: false,
      index: 2,
      heading: 'Routing',
      templateUrl: 'management/routing-group/routing.group.html'
    },
    CHECKLIST: {
      active: false,
      index: 3,
      heading: 'Checklist',
      templateUrl: 'management/checklist/checklist.html'
    }
  };
  ctrl.init = function () {
    if (ProfileService.isSuperUser()) {
      // eslint-disable-next-line dot-notation
      ctrl.tabs['CONFIGURATION'] = {
        active: false,
        index: 4,
        heading: 'Configuration',
        templateUrl: 'management/configuration/configuration.html'
      };
    }
    ctrl.initPrograms(programs);
    ctrl.initActiveProgram();
    ctrl.initActiveTab();
  };
  ctrl.initPrograms = function (prog) {
    ctrl.programs = prog;
    ctrl.programsForList = [];
    _.chain(prog).groupBy('campusCode').sortBy(['campusCode']).value().forEach(function (value) {
      ctrl.programsForList.push({
        "class": 'divider'
      });
      ctrl.programsForList = [].concat((0, _toConsumableArray2["default"])(ctrl.programsForList), (0, _toConsumableArray2["default"])(value));
    });
    ctrl.programsForList.shift();
  };
  ctrl.selectProgram = function (program) {
    if (program && program._id) {
      ctrl.selectedProgram = ctrl.programs.find(function (p) {
        return p._id === program._id;
      });
      $location.search('member', null).search('program', ctrl.selectedProgram._id).replace();
    }
  };
  ctrl.initActiveProgram = function () {
    if ($location.search().program) {
      ctrl.selectProgram({
        _id: $location.search().program
      });
    } else {
      ctrl.selectProgram(ctrl.programs[0]);
    }
  };
  ctrl.initActiveTab = function () {
    var initialActiveTab = $location.search().activeTab || 'PARTY';
    ctrl.setActiveTab(initialActiveTab);
  };
  ctrl.setActiveTab = function (tabKey) {
    ctrl.activeTab = ctrl.tabs[tabKey] ? ctrl.tabs[tabKey].index : 0;
    $location.search('activeTab', tabKey || 'PARTY').replace();
  };
  ctrl.deleteProgram = function (program) {
    $uibModal.open({
      templateUrl: 'management/_program.delete.confirm.html',
      controllerAs: '$ctrl',
      backdrop: 'static',
      // eslint-disable-next-line object-shorthand
      controller: /*@ngInject*/function controller($uibModalInstance) {
        var $ctrl = this;
        $ctrl.ok = function () {
          ProgramService["delete"]({
            id: program._id
          }).$promise.then(function () {
            $location.path('/');
            $uibModalInstance.dismiss('cancel');
          });
        };
        $ctrl.cancel = function () {
          $uibModalInstance.dismiss('cancel');
        };
      }
    });
  };
  ctrl.setAction = function (action, data) {
    if (action === NEW_PROGRAM) {
      // eslint-disable-next-line no-param-reassign
      data.active = true;
      ctrl.modal = $uibModal.open({
        templateUrl: 'management/_program-form.html',
        // eslint-disable-next-line no-undef
        appendTo: angular.element(document.querySelector('#management-page')),
        // eslint-disable-next-line object-shorthand
        controller: /*@ngInject*/function controller($uibModalInstance) {
          var $ctrl = this;
          $ctrl.action = NEW_PROGRAM;
          $ctrl.program = ctrl.program;
          $ctrl.program.sync = false;
          $ctrl.program.integratedWith = null;
          $ctrl.integratedApps = ['radiation'];
          $ctrl.campuses = ctrl.campuses;
          $ctrl.submit = function () {
            return ctrl.submit(action, $ctrl.program);
          };
          $ctrl.cancel = function () {
            $uibModalInstance.dismiss('cancel');
            ctrl.setAction(null, null);
          };
          $ctrl.setProgramCampus = function (campus) {
            $ctrl.program.campusCode = campus.campusCode;
            $ctrl.validate('program-name');
          };
          $ctrl.validate = function (field) {
            $ctrl['program-form'][field].$error.duplicate = _.some(ctrl.programs, {
              name: ctrl.program.name,
              campusCode: ctrl.program.campusCode
            });
            $ctrl['program-form'].$setValidity('duplicate', !$ctrl['program-form'][field].$error.duplicate, $ctrl['program-form'][field]);
          };
        },
        controllerAs: '$ctrl',
        backdrop: 'static'
      });
      ctrl.program = data;
    }
    if (action === EDIT_PROGRAM) {
      ctrl.modal = $uibModal.open({
        templateUrl: 'management/_program-form.html',
        // eslint-disable-next-line no-undef
        appendTo: angular.element(document.querySelector('#management-page')),
        // eslint-disable-next-line object-shorthand
        controller: /*@ngInject*/function controller($uibModalInstance) {
          var $ctrl = this;
          $ctrl.action = EDIT_PROGRAM;
          $ctrl.campuses = ctrl.campuses;
          $ctrl.integratedApps = ['radiation'];
          // eslint-disable-next-line no-undef
          $ctrl.program = angular.copy(data);
          $ctrl.campus = ctrl.campuses.find(function (campus) {
            return campus.campusCode === $ctrl.program.campusCode;
          });
          $ctrl.submit = function () {
            return ctrl.submit(action, $ctrl.program);
          };
          $ctrl.cancel = function () {
            $uibModalInstance.dismiss('cancel');
            ctrl.setAction(null, null);
          };
          $ctrl.setProgramCampus = function (campus) {
            $ctrl.program.campusCode = campus.campusCode;
            $ctrl.validate('program-name');
          };
          $ctrl.validate = function (field) {
            $ctrl['program-form'][field].$error.duplicate = ctrl.programs.some(function (program) {
              return program.name === $ctrl.program.name && program.campusCode === $ctrl.program.campusCode && program._id !== $ctrl.program._id;
            });
            $ctrl['program-form'].$setValidity('duplicate', !$ctrl['program-form'][field].$error.duplicate, $ctrl['program-form'][field]);
          };
        },
        controllerAs: '$ctrl',
        backdrop: 'static'
      });
      ctrl.program = data;
    }
    ctrl.action = action;
  };
  ctrl.getCampusName = function (campusCode) {
    switch (campusCode) {
      case '-1':
        return 'Shared CheckList Program';
      default:
        // eslint-disable-next-line no-case-declarations
        var campus = ctrl.campuses.find(function (c) {
          return c.campusCode === campusCode;
        });
        return campus ? campus.name : campusCode;
    }
  };
  ctrl.submit = function (action, data) {
    if (action === NEW_PROGRAM) {
      // eslint-disable-next-line no-param-reassign
      data._id = new ObjectId();
      // eslint-disable-next-line no-param-reassign
      data.members = [];
      // eslint-disable-next-line no-param-reassign
      data.configurations = [];
      ProgramService.save({
        id: undefined
      }, data).$promise.then(function () {
        ctrl.modal.close();
        ctrl.programs.push(data);
        ctrl.initialPageSetUp(ctrl.programs, data);
      })["catch"]();
    } else if (action === EDIT_PROGRAM) {
      ProgramService.update({
        id: data._id
      }, data).$promise.then(function () {
        ctrl.modal.close();
        var index = _.findIndex(ctrl.programs, function (program) {
          return program._id.toString() === data._id.toString();
        });
        if (index !== -1) {
          ctrl.programs.splice(index, 1, data);
        }
        ctrl.initialPageSetUp(ctrl.programs, data);
      })["catch"]();
    }
  };
  ctrl.initialPageSetUp = function (prog, data) {
    ctrl.initPrograms(prog);
    ctrl.selectProgram(data);
    ctrl.setActiveTab('CONFIGURATION');
  };
};